<template>
  <div>
    <el-tabs type="border-card" v-model="currentTab">
      <el-tab-pane label="停车场信息" name="common">
        
         <form-panel ref="formPanel" @saved="onFormSaved"></form-panel>
      </el-tab-pane>
      <el-tab-pane label="通道信息" name="channel" :disabled="!this.id">
        <channel-panel ref="channelPanel"></channel-panel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style lang="less">
.xszPanel li {
  float: left;
  margin: 3px;
  background: #eee;
  padding: 5px;
  text-align: center;
  color: gray;
  .el-upload-dragger {
    width: 250px;
    height: 150px;
  }
  img {
  }
}
</style>

<script>
import FormPanel from "./Form";
import ChannelPanel from './Channel';

export default {
  components: { FormPanel,ChannelPanel },
  data() {
    return {
      id: null,
      currentTab:'common'
    };
  },
  methods: {
    onFormSaved(id) {
      this.id = id;
      this.$refs.channelPanel.$emit("init", { parkId: this.id });
      this.$message('操作成功!');
    },
    submit() {
      this.$refs.formPanel.$emit("submit");
    },
    init(options = {}) {
      this.currentTab = 'common';
      this.id = options.id;
      this.$refs.formPanel.$emit("init", options);
      this.$refs.channelPanel.$emit('init',{parkId:this.id});
    }
  },

  created() {
    this.$on("init", this.init);
    this.$on("submit", this.submit);
  }
};
</script>


// WEBPACK FOOTER //
// Edit.vue?bf17f86e